<script>
	import { onMount } from "svelte";
	import Cropper from "./Cropper.svelte";
	import { clamp } from "./clamp.js";

	let settingsElement = document.querySelector("#editor_image_url");
	let src = settingsElement.dataset.editorUrl;
	const defaultLength = parseInt(
		settingsElement.dataset.editorDefaultLength,
		10
	);
	const defaultWidth = parseInt(settingsElement.dataset.editorDefaultWidth, 10);

	// These constraints vary per Product and are hardcoded until we configure them in WP at some point
	let MIN_WIDTH = 60; // made up number, could be anything
	const MAX_WIDTH = Infinity;
	const MIN_HEIGHT = 10;
	const MAX_HEIGHT = 1000;

	let mounted;

	// Calculated values based on WP form fields
	let width;
	let height;
	let ratio;
	let material_type;
	let roll_width = 70;
	let rolls = [];
	let flipped = false;
	let grayscale = false;
	let crop;
	let preview_image;
	let crop_percentages;

	function get_material_type(value) {
		if (!value) return "sheet";
		if (value.includes("stuk")) {
			return "sheet";
		}
		if (value.includes("rol")) {
			return "roll";
		}
		return "sheet";
	}

	onMount(() => {
		mounted = true;

		document.addEventListener("input", (event) => {
			if (event.target.id === "width_needed") {
				width = parseInt(event.target.value, 10);
			}
			if (event.target.id === "length_needed") {
				height = parseInt(event.target.value, 10);
			}
		});

		document.addEventListener("change", (event) => {
			if (event.target.id === "pa_materiaal") {
				material_type = get_material_type(event.target.value);
				document.body.dataset.materialType = material_type;
			}
		});

		material_type = get_material_type(
			document.querySelector("#pa_materiaal").value
		);

		var interval = setInterval(elementChecker, 200);
		var widthElement;
		var heightElement;

		function elementChecker() {
			widthElement = document.querySelector("#width_needed");
			heightElement = document.querySelector("#length_needed");
			if (!widthElement || !heightElement) return;

			// Stop polling for the elements
			clearInterval(interval);

			width = widthElement.value
				? parseInt(widthElement.value, 10)
				: defaultWidth;
			height = heightElement.value
				? parseInt(heightElement.value, 10)
				: defaultLength;

			// Add input listeners
			widthElement.addEventListener("input", function (event) {
				width = parseInt(event.target.value, 10);
			});
			heightElement.addEventListener("input", function (event) {
				height = parseInt(event.target.value, 10);
			});

			document.querySelector(".price-table-row.length-input").style.display =
				"none";
			document.querySelector(".price-table-row.width-input").style.display =
				"none";

			var table = document.querySelector("table.variations");
			var tbody = table.querySelector("tbody");
			var heightInput = document.querySelector("#length_needed");
			var widthInput = document.querySelector("#width_needed");

			var newHeightInput = document.createElement("input");
			newHeightInput.type = "number";
			newHeightInput.size = 12;
			newHeightInput.style.width = "auto";
			newHeightInput.value = height;

			var newWidthInput = document.createElement("input");
			newWidthInput.type = "number";
			newWidthInput.size = 12;
			newWidthInput.style.width = "auto";
			newWidthInput.value = width;

			var widthLabel = document.createElement("label");
			widthLabel.for = newWidthInput.id;
			widthLabel.textContent =
				document.querySelector("[for=width_needed]").innerText;

			var heightLabel = document.createElement("label");
			heightLabel.for = newHeightInput.id;
			heightLabel.textContent = document.querySelector(
				"[for=length_needed]"
			).innerText;

			var tdWidthLabel = document.createElement("td");
			tdWidthLabel.appendChild(widthLabel);
			tdWidthLabel.classList.add("label");

			var tdHeightLabel = document.createElement("td");
			tdHeightLabel.appendChild(heightLabel);
			tdHeightLabel.classList.add("label");

			var tdWidthValue = document.createElement("td");
			tdWidthValue.classList.add("value");
			tdWidthValue.appendChild(newWidthInput);

			var tdHeightValue = document.createElement("td");
			tdHeightValue.classList.add("value");
			tdHeightValue.appendChild(newHeightInput);

			var trWidth = document.createElement("tr");
			trWidth.appendChild(tdWidthLabel);
			trWidth.appendChild(tdWidthValue);

			var trHeight = document.createElement("tr");
			trHeight.appendChild(tdHeightLabel);
			trHeight.appendChild(tdHeightValue);

			var flipInput = document.createElement("input");
			flipInput.type = "checkbox";
			flipInput.checked = false;
			flipInput.onchange = function (event) {
				flipped = event.target.checked;
			};
			var flipLabel = document.createElement("label");
			flipLabel.classList.add("no-colon");
			var flipLabelText = document.createTextNode("Afbeelding spiegelen");
			flipLabel.appendChild(flipInput);
			flipLabel.appendChild(flipLabelText);
			var tdFlip = document.createElement("td");
			tdFlip.appendChild(flipLabel);
			tdFlip.classList.add("pull-back");
			var trFlip = document.createElement("tr");
			trFlip.appendChild(document.createElement("td"));
			trFlip.appendChild(tdFlip);

			var grayscaleInput = document.createElement("input");
			grayscaleInput.type = "checkbox";
			grayscaleInput.checked = false;
			grayscaleInput.onchange = function (event) {
				grayscale = event.target.checked;
			};
			var grayscaleLabel = document.createElement("label");
			grayscaleLabel.classList.add("no-colon");
			var grayscaleLabelText = document.createTextNode("Zwart-wit");
			grayscaleLabel.appendChild(grayscaleInput);
			grayscaleLabel.appendChild(grayscaleLabelText);
			var tdGrayscale = document.createElement("td");
			tdGrayscale.appendChild(grayscaleLabel);
			tdGrayscale.classList.add("pull-back");
			var trGrayscale = document.createElement("tr");
			trGrayscale.appendChild(document.createElement("td"));
			trGrayscale.appendChild(tdGrayscale);

			function onWidthChange(event) {
				roll_width = parseInt(event.target.value, 10);
			}

			var tdRollLabel = document.createElement("td");
			tdRollLabel.classList.add("label");
			var rollWidthLabel = document.createElement("label");
			rollWidthLabel.appendChild(document.createTextNode("Rolbreedte"));
			tdRollLabel.appendChild(rollWidthLabel);
			var tdRollWidth = document.createElement("td");
			[53, 70].forEach((width) => {
				var input = document.createElement("input");
				input.type = "radio";
				input.name = "roll_width";
				input.value = width;
				input.onchange = onWidthChange;
				input.checked = width === roll_width;

				var label = document.createElement("label");
				label.classList.add("no-colon");
				label.appendChild(input);
				label.appendChild(document.createTextNode(width + " cm rol"));

				tdRollWidth.appendChild(label);
			});
			var trRollWidth = document.createElement("tr");
			trRollWidth.classList.add("roll-width");
			trRollWidth.appendChild(tdRollLabel);
			trRollWidth.appendChild(tdRollWidth);

			tbody.insertBefore(trWidth, tbody.firstChild);
			tbody.insertBefore(trHeight, tbody.firstChild);
			tbody.lastChild.after(trRollWidth);
			tbody.lastChild.after(trFlip);
			tbody.lastChild.after(trGrayscale);

			newHeightInput.addEventListener("input", function (event) {
				heightInput.value = event.target.value;
				// To trigger our Cropper
				heightInput.dispatchEvent(new Event("input"));
				// To trigger WooCommerce price updates
				heightInput.dispatchEvent(new Event("keyup"));
			});
			newWidthInput.addEventListener("input", function (event) {
				widthInput.value = event.target.value;
				// To trigger our Cropper
				widthInput.dispatchEvent(new Event("input"));
				// To trigger WooCommerce price updates
				widthInput.dispatchEvent(new Event("keyup"));
			});
		}
	});

	$: if (roll_width) MIN_WIDTH = roll_width;
	$: clampedWidth = clamp(MIN_WIDTH, width, MAX_WIDTH);
	$: clampedHeight = clamp(MIN_HEIGHT, height, MAX_HEIGHT);
	$: ratio = clampedWidth / clampedHeight;

	$: if (
		material_type === "roll" &&
		roll_width &&
		clampedWidth &&
		clampedHeight
	) {
		var roll_count = Math.ceil(clampedWidth / roll_width);
		rolls = new Array(roll_count).fill({}).map((roll, index, arr) => {
			// Only show measure if not last item
			const showMeasure = index < arr.length - 1;
			// Show name if not last item
			// OR is last item > 66% shown
			const percentageShown = clampedWidth / roll_width - (roll_count - 1);
			const showName =
				index < arr.length - 1 ||
				(index === arr.length - 1 && percentageShown > 0.66);

			return {
				cssOffset: (roll_width / clampedWidth) * index,
				cssWidth: roll_width / clampedWidth,
				measure: showMeasure ? String(roll_width * (index + 1)) : undefined,
				name: showName ? String(index + 1) : undefined,
			};
		});
	}

	$: if (mounted) {
		// Update a hidden input with all variables that we need to produce the actual order
		const order_data = {
			crop,
			flipped,
			grayscale,
			roll_width,
			cropper_width: clampedWidth,
			cropper_height: clampedHeight,
			cropper_ratio: ratio,
			preview_image,
			crop_percentages,
		};
		document.querySelector('[name="orderData"]').value =
			JSON.stringify(order_data);
	}
</script>

<div class="app">
	<div class="cropper" class:grayscale>
		{#if ratio}
			<Cropper
				on:crop={(event) => {
					crop = event.detail.crop;
					preview_image = event.detail.preview_image;
					crop_percentages = event.detail.crop_percentages;
				}}
				aspect_ratio={ratio}
				{src}
				{flipped}
			>
				<div class="overlay">
					{#if material_type === "roll" && rolls}
						<ol class="rolls">
							{#each rolls as roll, index (roll)}
								<li
									class="roll"
									style="left: {roll.cssOffset * 100}%; width: {roll.cssWidth *
										100}%;"
								>
									{#if roll.name}
										<span class="roll_name">{roll.name}</span>
									{/if}
									{#if roll.measure}
										<span class="measure roll_measure">{roll.measure}cm</span>
									{/if}
								</li>
							{/each}
						</ol>
					{/if}
					<span class="measure measure--is-x-start">0cm</span>
					<span class="measure measure--is-x-end">{clampedWidth}cm</span>
					<span class="measure measure--is-y-end">{clampedHeight}cm</span>
				</div>
			</Cropper>
		{:else}
			<img {src} alt="alt" />
		{/if}
	</div>
</div>

<style>
	:global(.cropper-view-box),
	:global(.cropper-canvas) {
		transition: filter 200ms ease-out;
	}

	:global(.grayscale .cropper-view-box),
	:global(.grayscale .cropper-canvas) {
		filter: grayscale(1);
	}

	.overlay,
	.rolls {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		pointer-events: none;
	}

	.roll {
		border-right: 1px dashed white;
		position: absolute;
		top: 0;
		height: 100%;
		text-align: center;
		display: flex;
		justify-content: flex-end;
		flex-direction: column;
		align-items: center;
	}

	.roll:last-child {
		border: none;
	}

	.roll_name {
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.2rem;
		text-shadow: 0 0 0.5em rgba(0, 0, 0, 0.9);
		font-weight: 700;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 0.1em 1em;
	}

	.roll_measure {
		top: 103%;
		right: 0;
		transform: translateX(50%);
	}

	.measure {
		position: absolute;
		color: white;
		font-size: 12px;
		font-weight: 700;
		line-height: normal;
		background-color: #e4002b;
		border-radius: 1px;
		padding: 0.1em 0.2em;
	}

	.measure--is-x-start {
		top: 103%;
		left: 0;
		transform: translateX(-50%);
	}

	.measure--is-x-end {
		top: 103%;
		right: 0;
		transform: translateX(50%);
	}

	.measure--is-y-end {
		top: -4%;
		right: 100%;
		transform: translateY(-50%) translateX(75%);
		margin-right: 1ch;
	}

	:global(label.no-colon) {
		display: inline-flex !important;
		align-items: baseline;
	}

	:global(label.no-colon::after) {
		content: none !important;
	}

	:global(tr.roll-width) {
		display: none;
	}
	:global([data-material-type="roll"] tr.roll-width) {
		display: table-row;
	}

	:global(td.pull-back input) {
		margin-right: 1ch;
	}

	:global(.price-table-row.total-amount td::after),
	:global(.price-table-row.calculated-price td::after) {
		line-height: normal;
	}
</style>
